module.exports = __webpack_public_path__ + "static/home-static-a0ba514a2fa1e5ace61899b9f191b2c5.jpg";